const stateManager = require('../state/stateManager');
const logger = require('../logger/logger');
const formatter = require('../formatter/formatter');
const basketUtil = require('../basket/basketUtil');
const stringUtil = require('../string/stringUtil.js');
const apiProxy = require('../api/apiProxy');

module.exports.isUserRegistrationRequired = function()
{
    var state = stateManager.getStore().getState();
    
    return state.user == null;
}

module.exports.sendReceiptToUser = function(basket)
{
    try
    {
        var user = stateManager.getStore().getState().user;
        const replyToAddress = stateManager.getStore().getState().emailReplyToAddress;

        if (user == null || stringUtil.isStringNullOrEmpty(user.emailAddress))
            return;

        var requestBody = {};
        requestBody.toEmailAddress = user.emailAddress;
        requestBody.replyToAddress = replyToAddress;
        requestBody.content = buildEmailContents(basket, user);
        requestBody.subject = `Order Confirmation - ${basket.order.number}`
        return apiProxy.post("email", requestBody)
                .then(result=>
                {
                }, error =>
                {
                    logger.error(`Error occured while sending email. ${error}`, {}, error)
                });
    }
    catch(error)
    {
        logger.error(`Error occurred while sending receipt to user. ${error}`, null, error);
    }
}

function buildEmailContents(basket, user)
{
    var state = stateManager.getStore().getState()

    var orderNumber = basket.order.number;
    var storeName = state.property.name;
    var storeAddress = state.property.address;
    var phoneNumber = state.property.phoneNumber;
    var userNameString = user.name ? `Hello ${user.name}. ` : '';


    var body = `<html>
                    <head>
                        <title>Order Confirmation</title>
                    </head>
                    <body>
                        <div style="text-align:center"><b>Thank You For Placing Order</b></div>
                        <hr style="text-align:center;margin-top:5px; margin-bottom: 30px"/>
                        <table style="width:100%">
                            <tr>
                                <td style="width:1%;white-space: nowrap;">
                                    <div style="margin-right:5px;">Store</div>
                                </td>
                                <td style="width:99%;white-space: nowrap;text-align:left;">
                                    <div>${storeName}</div>
                                </td>
                            </tr>

                            <tr>
                                <td style="width:1%;white-space: nowrap;">
                                    <div style="margin-right:5px;">Address</div>
                                </td>
                                <td style="width:99%;white-space: nowrap;text-align:left;">
                                    <div>${storeAddress}</div>
                                </td>
                            </tr>

                            <tr>
                                <td style="width:1%;white-space: nowrap;">
                                    <div style="margin-right:5px;">Phone Number</div>
                                </td>
                                <td style="width:99%;white-space: nowrap;text-align:left;">
                                    <div>${phoneNumber}</div>
                                </td>
                            </tr>

                            <tr>
                                <td style="width:1%;white-space: nowrap;">
                                    <div style="margin-right:5px;">Order Number</div>
                                </td>
                                <td style="width:99%;white-space: nowrap;text-align:left;">
                                    <div>${orderNumber}</div>
                                </td>
                            </tr>
                        </table>
                        <hr style="text-align:center;margin-top:5px; margin-bottom: 20px"/>
                        <b>${userNameString}Your Order Details are as below</b><br/><br/>
                        <table style="width:100%">`;

    basket.order.saleItems.forEach(saleItem =>
    {
        body = body + buildOrderLineEmailContent(saleItem, false, 0)  
        body = body + `<tr><td colspan="3"><div style="margin-bottom:10px"></div></td></tr>`      
    })
    
    body = body + "</table>";
    body = body + `<hr style="text-align:center;margin-top:5px; margin-bottom: 20px"/>`;

    body = body + buildOrderPaymentSummaryEmailContent(basket.order);
    body = body + `</body></html>`;

    return body;
}

function buildOrderLineEmailContent(saleItem, isSubItem, marginLeft)
{
    var quantityCaption = "";
    var priceCaption = "";

    if (!isSubItem)
        quantityCaption = `${saleItem.quantity}x`;

    if (saleItem.unitPrice > 0)
        priceCaption = `${formatter.convertToCurrencyFormat(saleItem.quantity * saleItem.unitPrice)}`;

    var body = `<tr>
                    <td style="width:1%;white-space: nowrap;">
                        <div style="margin-right:5px;">${quantityCaption}</div>
                    </td>
                    <td style="width:99%;white-space: nowrap;text-align:left;">
                        <div style="margin-left:${marginLeft}px; margin-right:5px;">${saleItem.caption}</div>
                    </td>
                    <td style="width:1%;white-space: nowrap;">
                        <div style="margin-right:5px;">${priceCaption}</div>
                    </td>
                </tr>`;

    saleItem.saleItems.forEach(saleSubItem =>
    {
        body = body + buildOrderLineEmailContent(saleSubItem, true, marginLeft + 10);       
    })

    return body;
}

function buildOrderPaymentSummaryEmailContent(order)
{
    return `<table style="width:100%">
                        <tr>
                            <td style="width:1%;white-space: nowrap;">
                                <div style="margin-right:5px;">Total Charges
                                </div>
                            </td> 
                            <td>
                                ${formatter.convertToCurrencyFormat(basketUtil.getTotalCharges())}
                            </td>
                        </tr>

                        <tr>
                            <td style="width:1%;white-space: nowrap;">
                                <div style="margin-right:5px;">Total Discounts
                                </div>
                            </td> 
                            <td>
                                ${formatter.convertToCurrencyFormat(basketUtil.getTotalDiscounts())}
                            </td>
                        </tr>

                        <tr>
                            <td style="width:1%;white-space: nowrap;">
                                <div style="margin-right:5px;">Total Sale
                                </div>
                            </td> 
                            <td>
                                ${formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}
                            </td>
                        </tr>

                        <tr>
                            <td style="width:1%;white-space: nowrap;">
                                <div style="margin-right:5px;">Total Paid Amount
                                </div>
                            </td> 
                            <td>
                                ${formatter.convertToCurrencyFormat(order.paidAmount)}
                            </td>
                        </tr>
            </table>`; 
}

